module.exports = __webpack_public_path__ + "static/media/monroe1.07def7a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/monroe/images/monroe1.jpg
// module id = 25
// module chunks = 0